import px0 from '/static/textures/environmentMaps/0/px.png'
import nx0 from '/static/textures/environmentMaps/0/nx.png'
import py0 from '/static/textures/environmentMaps/0/py.png'
import ny0 from '/static/textures/environmentMaps/0/ny.png'
import pz0 from '/static/textures/environmentMaps/0/pz.png'
import nz0 from '/static/textures/environmentMaps/0/nz.png'

import px1 from '/static/textures/environmentMaps/1/px.png'
import nx1 from '/static/textures/environmentMaps/1/nx.png'
import py1 from '/static/textures/environmentMaps/1/py.png'
import ny1 from '/static/textures/environmentMaps/1/ny.png'
import pz1 from '/static/textures/environmentMaps/1/pz.png'
import nz1 from '/static/textures/environmentMaps/1/nz.png'

import baseColor from '/static/textures/base/base_color.png'
import baseColorDark from '/static/textures/base/base_colorDark.png'
import baseRoughness from '/static/textures/base/base_roughness.png'
import baseNormal from '/static/textures/base/base_normal.png'

import razor from '/static/models/LFRazor5AniDrac3.glb?url'
import base from '/static/models/LFBase.glb?url'

import font from '/static/fonts/Quiche_Sans_Bold.json?url'
export default [
    {
        name: 'Quiche_Sans_Bold',
        type: 'font',
        path: font
    },
    {
        name: 'baseColorTexture',
        type: 'texture',
        path: baseColor
    },
    {
        name: 'baseColorDarkTexture',
        type: 'texture',
        path: baseColorDark
    },
    {
        name: 'baseRoughnessTexture',
        type: 'texture',
        path: baseRoughness
    },
    {
        name: 'baseNormalTexture',
        type: 'texture',
        path: baseNormal
    },
    {
        name: 'environmentMap',
        type: 'cubeTexture',
        path: [px0, nx0, py0, ny0, pz0, nz0]
    },
    {
        name: 'environmentMapDark',
        type: 'cubeTexture',
        path: [px1, nx1, py1, ny1, pz1, nz1]
    },
    {
        name: 'razorModel',
        type: 'gltfModel',
        path: razor
    },
    {
        name: 'baseModel',
        type: 'gltfModel',
        path: base
    }

]